import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import App from './App'
import { ThemeProvider, CssBaseline, customTheme, SnackbarComponent, ScrollToTop } from './components';
import { AuthProvider, InitNetworkStatus } from './utils';
import { SnackbarProvider } from './hooks';
import { GoogleOAuthProvider } from '@react-oauth/google';
import { LocalizationProvider } from '@mui/x-date-pickers';
import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFns';
import LogRocket from 'logrocket';
import { App as CapacitorApp } from '@capacitor/app';

import 'mapbox-gl/dist/mapbox-gl.css';
import 'cropperjs/dist/cropper.css';

if (import.meta.env.PROD) {
  LogRocket.init('qojixp/panam-explorer');
}

InitNetworkStatus();

CapacitorApp.addListener('appStateChange', (state) => {
  if (state.isActive) {
    InitNetworkStatus();
  }
});

if ("serviceWorker" in navigator) {
  window.addEventListener("load", () => {
    navigator.serviceWorker.register("/sw.js");
  });
}

createRoot(document.getElementById('root')).render(
  <StrictMode>
    <GoogleOAuthProvider clientId={import.meta.env.VITE_GOOGLE_CLIENT_ID}>
      <ThemeProvider theme={customTheme}>
        <CssBaseline />
          <BrowserRouter>
            <ScrollToTop />
            <AuthProvider>
              <SnackbarProvider>
                <LocalizationProvider dateAdapter={AdapterDateFns}>
                  <SnackbarComponent />
                  <App />
                </LocalizationProvider>
              </SnackbarProvider>
            </AuthProvider>
          </BrowserRouter>
      </ThemeProvider>
    </GoogleOAuthProvider>
  </StrictMode>
)
